import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import ET3PageDiv from "../../../core/et3-page-div";
import React from "react";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import KhattabatDataForm from "./khattabat-data-form";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import Et3Table from "../../../core/et3-table";
import { KHATTABAT_DATA_COLLECTION_HEADERS } from "../../../constants/table-custom-headers/Khattabat";
import { SupervisorKhattabatDataStore } from "../../../stores/supervisor-store/supervisor-khattabat-data-store";
import Et3Button from "../../../core/et3-button";

const KhattabatData = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_DATA_COLLECTION",
      "KHATTABAT_DATA_COLLECTION"
    );
  }, []);

  const dataCollection =
    SupervisorKhattabatDataStore().khattabatDataCollection.get();
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("KHATTABAT_DATA")}
        subTitle={i18n.get("KHATTABAT_DATA")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <KhattabatDataForm />
      <Et3Margin top={30} bottom={10} left={0} right={0} />
      <Et3Table
        columns={KHATTABAT_DATA_COLLECTION_HEADERS}
        title={i18n.get("DATA_COLLECTION")}
        rows={dataCollection}
        shouldBeFlagged={false}
        titleKey={"DATA_COLLECTION"}
      />
      <Et3PageTitle
        title={i18n.get("DATA_COLLECTION")}
        subTitle={i18n.get("EXPORT_TO_CSV_FILE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          SupervisorKhattabatDataStore().getAllKhattabatClientsData();
        }}
        size="LARGE"
        type="APPROVE"
        text="DOWNLOAD_CSV"
      />
    </ET3PageDiv>
  );
});
export default KhattabatData;
